// Kleine schakelknop linksonder op de kaart om tussen de PDOK luchtfoto
// (satelliet-look) en de PDOK BRT-A topografische kaart te wisselen.

import { useStore } from "../state/store";
import { Satellite, Map as MapIcon } from "lucide-react";
import { Button } from "./ui/Button";

export function BasemapToggle() {
  const basemap = useStore((s) => s.basemap);
  const setBasemap = useStore((s) => s.setBasemap);
  const viewMode = useStore((s) => s.viewMode);
  if (viewMode !== "2d") return null;

  return (
    <div className="absolute left-3 bottom-12 z-20 inline-flex border border-border rounded-md overflow-hidden bg-card/95 backdrop-blur shadow">
      <Button
        variant={basemap === "sat" ? "active" : "ghost"}
        size="sm"
        onClick={() => setBasemap("sat")}
        title="Luchtfoto"
        className="rounded-none border-0"
      >
        <Satellite size={14} /> Luchtfoto
      </Button>
      <Button
        variant={basemap === "topo" ? "active" : "ghost"}
        size="sm"
        onClick={() => setBasemap("topo")}
        title="Topografische kaart"
        className="rounded-none border-0"
      >
        <MapIcon size={14} /> Kaart
      </Button>
    </div>
  );
}
